class QuoteSystem {
  constructor() {
    this.apiUrl = 'https://api.instijlmedia.nl/forms/selectkantoormeubelen/offerte.php';
    // this.apiUrl = "https://lemur-unified-slug.ngrok-free.app/offerte.php";
    this.quoteItems = this.getQuoteItems();
    this.init();
  }

  init() {
    this.initEventListeners();
    this.updateQuoteCounter();
    this.initQuotePage();
  }

  initEventListeners() {
    // Add to quote buttons
    document.addEventListener('click', (e) => {
      if (e.target.closest('.add-to-quote-btn')) {
        e.preventDefault();
        this.handleAddToQuote(e.target.closest('.add-to-quote-btn'));
      }
    });

    // Quote form submission
    const quoteForm = document.querySelector('#quote-form');
    if (quoteForm) {
      quoteForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submitQuote();
      });
    }

    // Remove from quote buttons
    document.addEventListener('click', (e) => {
      if (e.target.closest('.remove-from-quote')) {
        e.preventDefault();
        const productId = e.target.closest('.remove-from-quote').dataset.productId;
        const productOptions = e.target.closest('.remove-from-quote').dataset.productOptions;
        this.removeFromQuote(productId, productOptions);
      }
    });

    // Update quantity
    document.addEventListener('change', (e) => {
      if (e.target.matches('.quote-quantity-input')) {
        const productId = e.target.dataset.productId;
        const productOptions = e.target.dataset.productOptions;
        const quantity = parseInt(e.target.value);
        this.updateQuantity(productId, productOptions, quantity);
      }
    });
  }

  handleAddToQuote(button) {
    const productForm = button.closest('form[action*="/cart/add"]');
    const productId = this.getProductId(productForm);
    const variantId = this.getVariantId(productForm);
    const quantity = this.getQuantity(productForm);
    
    const optionsForm = document.querySelector('.best-custom-product-options form[action*="/cart/add"]');
    const options = this.getOptions(optionsForm);

    if (!productId || !variantId) {
      console.error('Product or variant ID not found');
      return;
    }

    const productData = this.extractProductData(productForm, productId, variantId, quantity, options);
    this.addToQuote(productData);

    this.updateQuoteBubble();
    
    // Visual feedback
    this.showNotification('Product toegevoegd aan offerte!');
    button.textContent = 'Toegevoegd aan offerte';
    button.disabled = true;
    
    setTimeout(() => {
      button.textContent = 'Toevoegen aan offerte';
      button.disabled = false;
    }, 2000);
  }

  getProductId(form) {
    const productInput = form.querySelector('input[name="id"], input[name="product-id"]');
    if (productInput) return productInput.value;
    
    // Try to extract from form action or data attributes
    const formAction = form.getAttribute('action');
    if (formAction && formAction.includes('product-id=')) {
      return formAction.split('product-id=')[1].split('&')[0];
    }
    
    return form.dataset.productId || null;
  }

  getVariantId(form) {
    const variantInput = form.querySelector('input[name="id"]:not([name="product-id"])');
    if (variantInput) return variantInput.value;
    
    const selectVariant = form.querySelector('select[name="id"]');
    if (selectVariant) return selectVariant.value;
    
    return null;
  }

  getQuantity(form) {
    const quantityInput = form.querySelector('input[name="quantity"]');
    return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
  }

  // get options
  getOptions(form) {
    const options = [];
    
    // Find all .selector-wrapper elements and get their select elements
    const selectorWrappers = Array.from(form.querySelectorAll('.selector-wrapper')).filter(wrapper => wrapper.style.display !== 'none');
    
    selectorWrappers.forEach(wrapper => {
        const select = wrapper.querySelector('select');
        const label = wrapper.querySelector('.bcpo-title');
        if (select) {
            let optionName = label.textContent;
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption && selectedOption.value) {
                options.push({
                    label: optionName,
                    value: selectedOption.textContent || selectedOption.value
                });
            }
        } else {
          const singleSelect = wrapper.querySelector('.single-option-selector');
          const value = wrapper.querySelector('.bcpo-value');
          if (singleSelect) {
            let optionName = label.textContent;
            let optionValue = value.textContent;
            if (optionName && optionValue) {
                options.push({
                    label: optionName,
                    value: optionValue
                });
            }
          }
        }
        
    });
    return options;
  }

  extractProductData(form, productId, variantId, quantity, options) {
    const productTitle = document.querySelector('.product__title, h1')?.textContent?.trim() || 'Unknown Product';
    const productUrl = window.location.href;
    const productImage = document.querySelector('.product-single__media img')?.src || '';

    // Get price if available
    const priceElement = document.querySelector('.price__current, .product__price');
    const price = priceElement ? this.extractPrice(priceElement.textContent) : '0';

    return {
      id: productId,
      variantId: variantId,
      title: productTitle,
      url: productUrl,
      image: productImage,
      quantity: quantity,
      price: price,
      options: options,
      addedAt: new Date().toISOString()
    };
  }

  extractPrice(priceText) {
    const match = priceText.match(/[\d,]+\.?\d*/);
    return match ? match[0].replace(',', '') : '0';
  }

  addToQuote(productData) {
    const existingIndex = this.quoteItems.findIndex(item => 
      item.id === productData.id && item.variantId === productData.variantId && JSON.stringify(item.options) === JSON.stringify(productData.options)
    );

    if (existingIndex !== -1) {
      this.quoteItems[existingIndex].quantity += productData.quantity;
    } else {
      this.quoteItems.push(productData);
    }

    this.saveQuoteItems();
    this.updateQuoteCounter();
    this.updateQuoteDisplay();
  }

  removeFromQuote(productId, productOptions) {
    this.quoteItems = this.quoteItems.filter(item => !(item.id === productId && JSON.stringify(item.options) === productOptions));
    this.saveQuoteItems();
    this.updateQuoteCounter();
    this.updateQuoteDisplay();
    this.updateQuoteBubble();
  }

  updateQuantity(productId, productOptions, quantity) {
    const item = this.quoteItems.find(item => item.id === productId && JSON.stringify(item.options) === productOptions);
    if (item) {
      item.quantity = Math.max(1, quantity);
      this.saveQuoteItems();
      this.updateQuoteDisplay();
      this.updateQuoteBubble();
    }
  }

  updateQuoteBubble() {
    const quoteCountElement = document.querySelector('.quote-count-bubble-total');
    if (quoteCountElement) {
      try {
        const storedData = localStorage.getItem("selectkantoormeubelen_quote");
        const products = JSON.parse(storedData);
        const totalQuantity = products.reduce((total, product) => {
          return total + Number(product.quantity || 0);
        }, 0);
        quoteCountElement.textContent = totalQuantity;
      } catch (error) {
        console.error('Fout bij het verwerken van de quote-data:', error);
        quoteCountElement.textContent = '0';
      }
    }
  }

  getQuoteItems() {
    try {
      return JSON.parse(localStorage.getItem('selectkantoormeubelen_quote') || '[]');
    } catch (e) {
      return [];
    }
  }

  saveQuoteItems() {
    localStorage.setItem('selectkantoormeubelen_quote', JSON.stringify(this.quoteItems));
  }

  updateQuoteCounter() {
    const counter = document.querySelector('.quote-counter');
    if (counter) {
      const totalItems = this.quoteItems.reduce((sum, item) => sum + item.quantity, 0);
      counter.textContent = totalItems;
      counter.style.display = totalItems > 0 ? 'inline-block' : 'none';
    }
  }

  initQuotePage() {
    if (window.location.pathname.includes('/pages/offerte')) {
      this.displayQuoteItems();
    }
  }

  displayQuoteItems() {
    const quoteItemsContainer = document.querySelector('#quote-items');
    if (!quoteItemsContainer) return;

    if (this.quoteItems.length === 0) {
      quoteItemsContainer.innerHTML = '<p>Je offerte is leeg. <a href="/collections/all">Bekijk onze producten</a></p>';
      return;
    }

    let html = '<div class="quote-items-list">';

    this.quoteItems.forEach(item => {
      html += `
        <div class="quote-item" data-product-id="${item.id}">
          <div class="quote-item__image">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="quote-item__details">
            <h3 class="quote-item__title">
              <a href="${item.url}">${item.title}</a>
            </h3>
            ${item.options.length > 0 ? `
              <div class="quote-item__options">
                ${item.options.map(option => `
                  <div class="quote-option">
                    <strong>${option.label}</strong> ${option.value}
                  </div>
                `).join('')}
              </div>
            ` : ''}
          </div>
          <div class="quote-item__quantity">
            <label for="qty-${item.id}">Aantal:</label>
            <input 
              type="number" 
              id="qty-${item.id}" 
              class="quote-quantity-input" 
              data-product-id="${item.id}"
              data-product-options='${JSON.stringify(item.options)}'
              value="${item.quantity}" 
              min="1"
            >
          <div class="quote-item__actions">
            <button type="button" class="remove-from-quote" data-product-id="${item.id}" data-product-options='${JSON.stringify(item.options)}'>
              Verwijderen
            </button>
          </div>
          </div>
        </div>
      `;
    });
    
    html += '</div>';
    quoteItemsContainer.innerHTML = html;
  }

  updateQuoteDisplay() {
    if (window.location.pathname.includes('/pages/offerte')) {
      this.displayQuoteItems();
    }
  }

  async submitQuote() {
    const form = document.querySelector('#quote-form');
    const formData = new FormData(form);
    
    // Validate required fields
    const requiredFields = ['company', 'firstname', 'email'];
    let isValid = true;
    
    requiredFields.forEach(field => {
      const input = form.querySelector(`[name="${field}"]`);
      if (!input || !input.value.trim()) {
        isValid = false;
        this.showError(input, 'Dit veld is verplicht');
      } else {
        this.clearError(input);
      }
    });

    if (!isValid) {
      this.showNotification('Vul alle verplichte velden in', 'error');
      return;
    }

    if (this.quoteItems.length === 0) {
      this.showNotification('Je offerte is leeg', 'error');
      return;
    }

    // Prepare data for API
    const requestData = {
      products: this.quoteItems,
      customer: {
        company: formData.get('company'),
        firstname: formData.get('firstname'),
        email: formData.get('email'),
        phone: formData.get('phone') || '',
        comment: formData.get('comment') || ''
      }
    };

    console.log(requestData);
    console.log(this.apiUrl);

    

    try {
      this.showLoader(true);
      
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });

      const result = await response.json();

      if (result.status === 'ok') {
        this.showNotification('Offerte succesvol verzonden! Je ontvangt een bevestiging per e-mail.', 'success');
        this.clearQuote();
        form.reset();
        
        // Redirect to thank you page after 2 seconds
        setTimeout(() => {
          window.location.href = '/pages/offerte-bedankt';
        }, 2000);
      } else {
        this.showNotification(result.response || 'Er is een fout opgetreden', 'error');
      }
    } catch (error) {
      console.log(error);
      this.showNotification('Er is een fout opgetreden. Probeer het opnieuw.', 'error');
    } finally {
      this.showLoader(false);
    }
  }

  clearQuote() {
    this.quoteItems = [];
    this.saveQuoteItems();
    this.updateQuoteCounter();
    this.updateQuoteDisplay();
  }

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `quote-notification quote-notification--${type}`;
    notification.innerHTML = `
      <span class="quote-notification__message">${message}</span>
      <button type="button" class="quote-notification__close">&times;</button>
    `;
    
    document.body.appendChild(notification);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 5000);
    
    // Close button
    notification.querySelector('.quote-notification__close').addEventListener('click', () => {
      notification.remove();
    });
  }

  showError(input, message) {
    this.clearError(input);
    const error = document.createElement('div');
    error.className = 'field-error';
    error.textContent = message;
    input.parentNode.appendChild(error);
    input.classList.add('field-error-input');
  }

  clearError(input) {
    const existingError = input.parentNode.querySelector('.field-error');
    if (existingError) {
      existingError.remove();
    }
    input.classList.remove('field-error-input');
  }

  showLoader(show) {
    const submitButton = document.querySelector('#quote-form button[type="submit"]');
    if (submitButton) {
      if (show) {
        submitButton.disabled = true;
        submitButton.textContent = 'Verzenden...';
      } else {
        submitButton.disabled = false;
        submitButton.textContent = 'Offerte verzenden';
      }
    }
  }
}

// Initialize quote system when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.quoteSystem = new QuoteSystem();
});

// Make it available globally for Shopify theme usage
window.QuoteSystem = QuoteSystem;
